import api from './api';

/**
 * Notifications API service.
 *
 * All endpoints require the user to be authenticated (JWT header is added
 * automatically by the Axios interceptor in api.js).
 */

/**
 * List notifications for the current user.
 *
 * @param {object} params
 * @param {boolean} [params.unread_only]  - Return only unread notifications.
 * @param {number}  [params.limit]        - Max results (default 50, max 100).
 * @param {number}  [params.offset]       - Pagination offset.
 * @returns {Promise<{ notifications: Array, total: number, unread_count: number }>}
 */
export const getNotifications = (params = {}) =>
  api.get('/api/notifications', { params }).then((res) => res.data);

/**
 * Get the unread notification count.
 * Lightweight endpoint designed for polling.
 *
 * @returns {Promise<{ unread_count: number }>}
 */
export const getUnreadCount = () =>
  api.get('/api/notifications/unread-count').then((res) => res.data);

/**
 * Mark a single notification as read.
 *
 * @param {number} id
 * @returns {Promise<{ message: string, notification: object }>}
 */
export const markAsRead = (id) =>
  api.put(`/api/notifications/${id}/read`).then((res) => res.data);

/**
 * Mark all notifications as read.
 *
 * @returns {Promise<{ message: string, updated: number }>}
 */
export const markAllAsRead = () =>
  api.put('/api/notifications/read-all').then((res) => res.data);

/**
 * Delete a single notification.
 *
 * @param {number} id
 * @returns {Promise<{ message: string }>}
 */
export const deleteNotification = (id) =>
  api.delete(`/api/notifications/${id}`).then((res) => res.data);

/**
 * Delete all read notifications.
 *
 * @returns {Promise<{ message: string, deleted: number }>}
 */
export const deleteReadNotifications = () =>
  api.delete('/api/notifications/read').then((res) => res.data);
